const apiurl = 'https://password-manager-vzf4.onrender.com';

export default apiurl;